import { Field, Section, SystemUser } from './types';

/** Users available to the User Information lookup fields. */
export const systemUsers: SystemUser[] = [
  { id: 'u-rhappel', name: 'Raymond Happel', role: 'Loan Officer', team: 'The Bullpen', email: 'rhappel@rcmlending.com' },
  { id: 'u-tbishop', name: 'Taylor Bishop', role: 'Sales Manager', team: 'The Bullpen', email: 'tbishop@rcmlending.com' },
  { id: 'u-kharrington', name: 'Kayla Harrington', role: 'P1 / Concierge', team: 'The Bullpen', email: 'kharrington@rcmlending.com' },
  { id: 'u-leddy', name: 'Lauren Eddy', role: 'P2 Processor', team: 'The Bullpen', email: 'leddy@rcmlending.com' },
  { id: 'u-nborchers', name: 'Nikki Borchers', role: 'Lock Desk', team: 'Capital Markets', email: 'nborchers@rcmlending.com' },
  { id: 'u-moehler', name: 'Miranda Oehler', role: 'Loan Partner', team: 'The Bullpen', email: 'moehler@rcmlending.com' },
  { id: 'u-dcaldwell', name: 'Devon Caldwell', role: 'Junior Loan Officer', team: 'Summit Group', email: 'dcaldwell@rcmlending.com' },
  { id: 'u-pnguyen', name: 'Priya Nguyen', role: 'Disclosure Desk', team: 'Compliance', email: 'pnguyen@rcmlending.com' },
  { id: 'u-malvarez', name: 'Marcus Alvarez', role: 'Fee Desk', team: 'Compliance', email: 'malvarez@rcmlending.com' },
  { id: 'u-shollis', name: 'Sydney Hollis', role: 'Doc Specialist', team: 'Closing', email: 'shollis@rcmlending.com' },
  { id: 'u-jokafor', name: 'Jordan Okafor', role: 'ICD Specialist', team: 'Compliance', email: 'jokafor@rcmlending.com' },
  { id: 'u-bwhitfield', name: 'Brooke Whitfield', role: 'Loan Officer Assistant', team: 'Summit Group', email: 'bwhitfield@rcmlending.com' },
  { id: 'u-cmarsh', name: 'Colin Marsh', role: 'CDS', team: 'Summit Group', email: 'cmarsh@rcmlending.com' },
  { id: 'u-arivera', name: 'Ana Rivera', role: 'Processing Manager', team: 'Lakeside', email: 'arivera@rcmlending.com' },
];

/**
 * Additional fields that exist on the loan object but are not placed on the
 * layout by default. Admins can add any of these into a section.
 */
export const fieldLibrary: Field[] = [
  { id: 'lib-escrowCompany', label: 'Escrow Company', type: 'text', value: '' },
  { id: 'lib-payoffAmount', label: 'Payoff Amount', type: 'currency', value: '' },
  { id: 'lib-annualPropertyTax', label: 'Annual Property Tax', type: 'currency', value: '' },
  { id: 'lib-hoiPremium', label: 'HOI Annual Premium', type: 'currency', value: '' },
  { id: 'lib-hoaDues', label: 'Monthly HOA Dues', type: 'currency', value: '' },
  { id: 'lib-monthlyPayment', label: 'Monthly P&I Payment', type: 'currency', value: '' },
  { id: 'lib-dtiRatio', label: 'DTI Ratio', type: 'percent', value: '' },
  { id: 'lib-parRate', label: 'Par Rate', type: 'percent', value: '' },
  { id: 'lib-discountPoints', label: 'Discount Points', type: 'percent', value: '' },
  { id: 'lib-originationFee', label: 'Origination Fee', type: 'currency', value: '' },
  { id: 'lib-srpAmount', label: 'SRP Amount', type: 'currency', value: '' },
  { id: 'lib-loanOfficerNmls', label: 'Loan Officer NMLS ID', type: 'text', value: '' },
  { id: 'lib-floodZone', label: 'Flood Zone', type: 'select', value: '', options: ['Yes', 'No', 'Pending Cert'] },
  { id: 'lib-subordinationRequired', label: 'Subordination Required', type: 'select', value: '', options: ['Yes', 'No'] },
  { id: 'lib-creditReportDate', label: 'Credit Report Date', type: 'date', value: '' },
  { id: 'lib-cdIssuedDate', label: 'CD Issued Date', type: 'date', value: '' },
  { id: 'lib-fundingDate', label: 'Funding Date', type: 'date', value: '' },
  { id: 'lib-borrowerPhone', label: 'Borrower Phone', type: 'text', value: '' },
  { id: 'lib-borrowerEmail', label: 'Borrower Email', type: 'text', value: '' },
  { id: 'lib-mailingAddress', label: 'Mailing Address', type: 'text', value: '' },
  { id: 'lib-underwriter', label: 'Underwriter', type: 'userLookup', value: '' },
  { id: 'lib-closer', label: 'Closer', type: 'userLookup', value: '' },
  { id: 'lib-funder', label: 'Funder', type: 'userLookup', value: '' },
  { id: 'lib-internalNotes', label: 'Internal Notes', type: 'textarea', value: '' },
];

/** Teams available to the Team lookup. */
export const teams: string[] = ['The Bullpen', 'Summit Group', 'Capital Markets', 'Compliance', 'Closing', 'Lakeside'];

/**
 * All loan record data recreated from the Salesforce field forms.
 * Field values map 1:1 with the original screens — nothing added or removed.
 */
export const sections: Section[] = [
  {
    id: 'loan-details',
    title: 'Loan Details',
    icon: 'FileText',
    fields: [
      { id: 'loanName', label: 'Loan Name', type: 'text', value: 'Rice, Kathy' },
      { id: 'quickNote', label: 'Quick Note', type: 'textarea', value: 'NEED: HOI, mtg stmt, HOA dues' },
      { id: 'baseLoanAmount', label: 'Base Loan Amount', type: 'currency', value: '292765.00' },
      {
        id: 'typeOfLoan',
        label: 'Type of Loan',
        type: 'select',
        value: 'FHA Streamline',
        options: ['FHA Streamline', 'Conventional', 'VA', 'USDA', 'Jumbo'],
      },
      { id: 'rcmLoanNumber', label: 'RCM Loan Number', type: 'text', value: '2605110013' },
      {
        id: 'loanRecordType',
        label: 'Loan Record Type',
        type: 'select',
        value: 'Refinance',
        options: ['Refinance', 'Purchase'],
        readOnly: true,
      },
      { id: 'stage', label: 'Stage', type: 'select', value: 'P2', options: ['P1', 'P2', 'P3', 'Closing'] },
      {
        id: 'vaDisabilityStatus',
        label: 'VA Disability Status',
        type: 'select',
        value: '',
        options: ['Yes', 'No', 'N/A'],
      },
      {
        id: 'workflowStatus',
        label: 'Workflow Status',
        type: 'select',
        value: 'Borrower Conditions',
        options: ['Borrower Conditions', 'Submitted', 'Approved', 'Clear to Close', 'Funded'],
      },
      { id: 'estimatedAppraisalValue', label: 'Estimated Appraisal Value', type: 'currency', value: '304900.00' },
      {
        id: 'leadSource',
        label: 'Lead Source',
        type: 'select',
        value: 'Telemarketing',
        options: ['Telemarketing', 'Referral', 'Web', 'Repeat Client'],
      },
      { id: 'expectedPrice', label: 'Expected Price', type: 'number', value: '100.250' },
      { id: 'totalLoanAmount', label: 'Total Loan Amount', type: 'currency', value: '297888.00' },
      {
        id: 'mortgageType',
        label: 'Mortgage Type',
        type: 'select',
        value: 'Fixed',
        options: ['Fixed', 'ARM'],
      },
      { id: 'interestRate', label: 'Interest Rate', type: 'percent', value: '5.750' },
      {
        id: 'refinancePurpose',
        label: 'Refinance Purpose',
        type: 'select',
        value: 'FHA Streamline',
        options: ['FHA Streamline', 'Cash Out', 'Rate & Term'],
      },
      { id: 'estCloseDate', label: 'Est Close Date', type: 'date', value: '' },
      {
        id: 'occupancy',
        label: 'Occupancy',
        type: 'select',
        value: 'Primary Residence',
        options: ['Primary Residence', 'Second Home', 'Investment'],
      },
      { id: 'ltv', label: 'LTV', type: 'percent', value: '97.700' },
      {
        id: 'propertyType',
        label: 'Property Type',
        type: 'select',
        value: 'Detached',
        options: ['Detached', 'Attached', 'Condo', 'Townhome'],
      },
      {
        id: 'loanPurpose',
        label: 'Loan Purpose',
        type: 'select',
        value: 'Refinance',
        options: ['Refinance', 'Purchase'],
      },
      { id: 'investor', label: 'Investor', type: 'text', value: 'Planet' },
      { id: 'term', label: 'Term', type: 'number', value: '30' },
      { id: 'investorLoanNumber', label: 'Investor Loan Number', type: 'text', value: '9102594388' },
      { id: 'fico', label: 'FICO', type: 'number', value: '650' },
      { id: 'ausRan', label: 'AUS Ran', type: 'text', value: 'N/A (Streamline)' },
      { id: 'waiveEscrow', label: 'Waive Escrow', type: 'select', value: 'No', options: ['Yes', 'No'] },
      { id: 'affordable', label: 'Affordable', type: 'select', value: '', options: ['Yes', 'No'] },
      {
        id: 'floatLeDisclosed',
        label: 'Was a Float LE Already Disclosed?',
        type: 'select',
        value: 'No',
        options: ['Yes', 'No'],
      },
      { id: 'applicationDate', label: 'Application Date', type: 'date', value: '2026-05-12' },
      { id: 'titleCompany', label: 'Title Company', type: 'text', value: 'Cosmo' },
      {
        id: 'rateLockAtReg',
        label: 'Rate Lock at Reg',
        type: 'select',
        value: 'Lock',
        options: ['Lock', 'Float'],
      },
      { id: 'lockExpirationDate', label: 'Lock Expiration Date', type: 'date', value: '2026-07-28' },
      { id: 'titleCompanyName', label: 'Title Company Name', type: 'text', value: 'COSMO' },
      { id: 'numberOfUnits', label: 'Number of Units', type: 'number', value: '1' },
      { id: 'orderAppraisal', label: 'Order Appraisal', type: 'text', value: '' },
      {
        id: 'appraisalType',
        label: 'Appraisal Type',
        type: 'select',
        value: 'N/A',
        options: ['N/A', 'Full', 'Drive-by', 'Desktop'],
      },
      { id: 'secondMortgage', label: 'Second Mortgage', type: 'select', value: 'No', options: ['Yes', 'No'] },
      { id: 'appraisalPayment', label: 'Appraisal Payment', type: 'currency', value: '' },
      { id: 'loanSaver', label: 'LoanSaver', type: 'text', value: '' },
      {
        id: 'addingRemovingTitle',
        label: 'Adding or Removing Individual on Title?',
        type: 'select',
        value: 'No',
        options: ['Yes', 'No'],
        hint: 'Indicates a change to the individuals listed on the property title.',
      },
      { id: 'optOutDate', label: 'Opt Out Date', type: 'date', value: '' },
      { id: 'closeCurrentMonth', label: 'Close Current Month', type: 'checkbox', value: false },
      { id: 'earliestCloseDate', label: 'Earliest Close Date', type: 'date', value: '2026-06-05' },
      { id: 'processingComments', label: 'Processing Comments', type: 'textarea', value: '' },
      { id: 'estimatedFirstPaymentDate', label: 'Estimated First Payment Date', type: 'date', value: '' },
      { id: 'rcmMonthSubmitted', label: 'RCM Month Submitted', type: 'text', value: 'April 26' },
      { id: 'isReDoc', label: 'Is This a Re Doc?', type: 'checkbox', value: false },
      { id: 'prepaymentPenalty', label: 'Prepayment Penalty', type: 'text', value: '' },
      { id: 'regToDisclose', label: 'Reg to Disclose', type: 'select', value: 'Yes', options: ['Yes', 'No'] },
      { id: 'closingInLlc', label: 'Closing in LLC', type: 'select', value: '', options: ['Yes', 'No'] },
    ],
  },
  {
    id: 'subject-property',
    title: 'Subject Property',
    icon: 'Home',
    fields: [
      { id: 'propertyAddress', label: 'Subject Property Address', type: 'text', value: '362 Tumbleweed Pl' },
      { id: 'propertyCounty', label: 'Subject Property County', type: 'text', value: 'Charles' },
      { id: 'propertyCity', label: 'Subject Property City', type: 'text', value: 'Waldorf' },
      { id: 'propertyState', label: 'Subject Property State', type: 'text', value: 'MD' },
      { id: 'propertyZip', label: 'Subject Property Zip Code', type: 'text', value: '20601' },
    ],
  },
  {
    id: 'contact-information',
    title: 'Contact Information',
    icon: 'UserRound',
    fields: [
      { id: 'accountName', label: 'Account Name', type: 'user', value: 'Kathy Rice' },
      { id: 'isCoBorrower', label: 'Is There a Co-Borrower?', type: 'select', value: 'No', options: ['Yes', 'No'] },
      {
        id: 'isNbsTitleHolder',
        label: 'Is There a NBS/Additional Title Holder?',
        type: 'select',
        value: 'No',
        options: ['Yes', 'No'],
      },
      { id: 'coBorrowerFirstName', label: 'Coborrower First Name', type: 'text', value: '' },
      { id: 'coBorrowerLastName', label: 'CoBorrower Last Name', type: 'text', value: '' },
      { id: 'coBorrowerEmail', label: 'CoBorrower Email', type: 'text', value: '' },
    ],
  },
  {
    id: 'user-information',
    title: 'User Information',
    icon: 'Users',
    fields: [
      { id: 'loanOfficer', label: 'Loan Officer', type: 'userLookup', value: 'Raymond Happel' },
      { id: 'team', label: 'Team', type: 'select', value: 'The Bullpen', options: teams },
      { id: 'manager', label: 'Manager', type: 'userLookup', value: 'Taylor Bishop' },
      { id: 'cds', label: 'CDS', type: 'userLookup', value: '' },
      { id: 'p1Concierge', label: 'P1/Concierge', type: 'userLookup', value: 'Kayla Harrington' },
      { id: 'jrLo', label: 'JR LO', type: 'userLookup', value: '' },
      { id: 'p2', label: 'P2', type: 'userLookup', value: 'Lauren Eddy' },
      { id: 'jrLoManager', label: 'JR LO Manager', type: 'userLookup', value: '' },
      { id: 'feeMaster', label: 'Fee Master', type: 'userLookup', value: '' },
      { id: 'loa', label: 'LOA', type: 'userLookup', value: '' },
      { id: 'docMaster', label: 'Doc Master', type: 'userLookup', value: '' },
      { id: 'lockMaster', label: 'Lock Master', type: 'userLookup', value: 'Nikki Borchers' },
      { id: 'hoiOrderedBy', label: 'HOI Ordered By', type: 'userLookup', value: 'Miranda Oehler' },
      { id: 'disclosureMaster', label: 'Disclosure Master', type: 'userLookup', value: '' },
      { id: 'titleOrderedBy', label: 'Title Ordered By', type: 'userLookup', value: 'Miranda Oehler' },
      { id: 'icdSpecialist', label: 'ICD Specialist', type: 'userLookup', value: '' },
      { id: 'appraisalOrderedBy', label: 'Appraisal Ordered By', type: 'userLookup', value: '' },
    ],
  },
];
